import React, { useState } from 'react';
import { Table } from 'react-bootstrap';
import './Results.css';
import ExcelData from '../ExcelData/ExcelData';

const Results = ({ results, TargetedKeywords }) => {
  const [targetedSearchTerm, setTargetedSearchTerm] = useState('');
  const [generalSearchTerm, setGeneralSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc', table: '' });

  // Filtered keyword lists
  const targetedResults = results.filter((item) =>
    TargetedKeywords.some(keyword => keyword.toLowerCase() === item.keyword.toLowerCase()) &&
    item.keyword.toLowerCase().includes(targetedSearchTerm.toLowerCase())
  );

  const nonTargetedResults = results.filter((item) =>
    !TargetedKeywords.some(keyword => keyword.toLowerCase() === item.keyword.toLowerCase()) &&
    item.keyword.toLowerCase().includes(generalSearchTerm.toLowerCase())
  );

  const visibleRowCount = 10;

  // Get the first targeted keyword for filename
  const firstTargetedKeyword = targetedResults.length > 0 ? targetedResults[0].keyword : 'Targeted_Keywords';
  const suggestedKeywordsFilename = `${firstTargetedKeyword}_Suggested_Keywords`;

  // Sorting function (independent sorting for both tables)
  const handleSort = (key, table) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.table === table) {
      direction = sortConfig.direction === 'asc' ? 'desc' : 'asc';
    }
    setSortConfig({ key, direction, table });
  };

  // Sorting logic for Targeted and Other keywords
  const sortData = (data, table) => {
    if (sortConfig.table !== table) return data;

    return [...data].sort((a, b) => {
      const aValue = a[sortConfig.key]?.toString().replace(/,/g, '') || '';
      const bValue = b[sortConfig.key]?.toString().replace(/,/g, '') || '';

      const numA = Number(aValue);
      const numB = Number(bValue);

      if (!isNaN(numA) && !isNaN(numB)) {
        return sortConfig.direction === 'asc' ? numA - numB : numB - numA;
      }
      return sortConfig.direction === 'asc'
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    });
  };

  return (
    <div className="results-container results-entrance">
      <div className="tables-wrapper">
        {/* Targeted Keywords Table */}
        <div className="table-box">
          <div className="table-header-row">
            <h4 className="table-title">🎯 Targeted Keywords ({targetedResults.length})</h4>
          
          </div>
          <input
            type="text"
            placeholder="Search Targeted Keywords..."
            value={targetedSearchTerm}
            onChange={(e) => setTargetedSearchTerm(e.target.value)}
            className="search-bar"
          />
          <div className="table-wrapper scroll-block">
            <Table className="table-custom">
              <thead className="sticky-header">
                <tr>
                  <th onClick={() => handleSort('keyword', 'targeted')} style={{ cursor: 'pointer' }}>
                    Keyword {sortConfig.key === 'keyword' && sortConfig.table === 'targeted' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ''}
                  </th>
                  <th onClick={() => handleSort('avgMonthlySearches', 'targeted')} style={{ cursor: 'pointer' }}>
                    Avg Monthly Searches {sortConfig.key === 'avgMonthlySearches' && sortConfig.table === 'targeted' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ''}
                  </th>
                  <th>Competition</th>
                </tr>
              </thead>
              <tbody>
                {sortData(targetedResults, 'targeted').map((result, index) => (
                  <tr key={index} className="highlighted-row">
                    <td>{result.keyword || 'N/A'}</td>
                    <td>{result.avgMonthlySearches?.toLocaleString() || 'N/A'}</td>
                    <td>{result.competition || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>

        {/* Non-Targeted Keywords Table */}
        <div className="table-box">
          <div className="table-header-row">
            <h4 className="table-title">📌 Suggested Keywords ({nonTargetedResults.length})</h4>
            
          </div>
          <input
            type="text"
            placeholder="Search Other Keywords..."
            value={generalSearchTerm}
            onChange={(e) => setGeneralSearchTerm(e.target.value)}
            className="search-bar"
          />
          <div className="table-wrapper scroll-block">
            <Table className="table-custom">
              <thead className="sticky-header">
                <tr>
                  <th onClick={() => handleSort('keyword', 'general')} style={{ cursor: 'pointer' }}>
                    Keyword {sortConfig.key === 'keyword' && sortConfig.table === 'general' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ''}
                  </th>
                  <th onClick={() => handleSort('avgMonthlySearches', 'general')} style={{ cursor: 'pointer' }}>
                    Avg Monthly Searches {sortConfig.key === 'avgMonthlySearches' && sortConfig.table === 'general' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ''}
                  </th>
                  <th>Competition</th>
                </tr>
              </thead>
              <tbody>
                {sortData(nonTargetedResults, 'general').map((result, index) => (
                  <tr key={index}>
                    <td>{result.keyword || 'N/A'}</td>
                    <td>{result.avgMonthlySearches?.toLocaleString() || 'N/A'}</td>
                    <td>{result.competition || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>

    <div className="export-wrapper">
      <div className="export-button targeted-export">
        <ExcelData results={targetedResults} fileName={firstTargetedKeyword} />
      </div>
      <div className="export-button non-targeted-export">
        <ExcelData results={nonTargetedResults} fileName={suggestedKeywordsFilename} />
      </div>
    </div>

      
    </div>
  );
};

export default Results;
